import type { FunctionComponent } from 'react'
import React from 'react'

import classnames from 'classnames'

import { InputV2 } from '../../Seatbelt2/BuildingBlocks/Forms/Input'
import { TypographyV2 } from '../../Seatbelt2/Foundations/Typography'
import styles from './CurrencyInput.module.scss'

export const CurrencyInput: FunctionComponent<CurrencyInputProps> = ({
  className,
  name,
  currencySymbol = '£',
  inputMode = 'decimal',
  placeholder = '0.00',
  id = name,
  ...rest
}) => (
  <div className={styles.wrapper}>
    <TypographyV2
      className={styles.currencySymbol}
      textStyle="sb-text-interface-body-small-strong"
      aria-hidden
    >
      {currencySymbol}
    </TypographyV2>
    <InputV2
      className={classnames(styles.input, className)}
      inputMode={inputMode}
      placeholder={placeholder}
      name={name}
      id={id}
      {...rest}
    />
  </div>
)

///////// IMPLEMENTATION /////////

export type CurrencyInputProps = {
  name: string
  currencySymbol?: string
} & Parameters<typeof InputV2>[0]
